module.exports = __webpack_public_path__ + "img/avin-big.567802cb.png";